var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.items.length && !_vm.loading ? _c('div', {
    staticClass: "not-found-message"
  }, [_vm._v(" Nothing to display here :( ")]) : _c('div', [_vm.filterProp ? _c('div', {
    staticClass: "filter"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.filterPlaceholder
    },
    model: {
      value: _vm.filterBy,
      callback: function ($$v) {
        _vm.filterBy = $$v;
      },
      expression: "filterBy"
    }
  })], 1) : _vm._e(), _vm.$route.path === '/product/experiments' ? _c('el-button', {
    staticClass: "archive-button",
    attrs: {
      "size": "mini",
      "round": ""
    },
    on: {
      "click": _vm.toggleArchived
    }
  }, [_vm._v(_vm._s(_vm.showArchived ? 'Hide Archived' : 'Show Archived'))]) : _vm._e(), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "stripe": "",
      "data": _vm.showArchived ? _vm.archivedItems : _vm.filteredItems,
      "max-height": "500"
    }
  }, [_c('div', {
    attrs: {
      "slot": "empty"
    },
    slot: "empty"
  }, [_vm._v("Nothing matches your filter...")]), _vm._l(_vm.columns, function (column) {
    return _c('el-table-column', {
      key: column.name,
      attrs: {
        "label": column.label,
        "prop": column.prop,
        "formatter": column.formatter
      }
    });
  }), _vm.actions && _vm.actions.length > 0 ? _c('el-table-column', {
    attrs: {
      "label": "Actions"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (s) {
        return [_c('div', {
          staticClass: "actions"
        }, _vm._l(_vm.actions.filter(function (a) {
          return !a.visible || a.visible(s.row);
        }), function (action) {
          return _c('div', {
            key: action.name,
            staticClass: "action"
          }, [action.requiresConfirm ? _c('Confirm', {
            attrs: {
              "title": action.title
            },
            on: {
              "confirm": function () {
                return action.onClick(s.row);
              }
            }
          }, [_c('el-button', {
            attrs: {
              "type": action.type,
              "size": "mini"
            }
          }, [_vm._v(" " + _vm._s(action.name) + " ")])], 1) : _c('el-button', {
            attrs: {
              "type": action.type,
              "size": "mini"
            },
            on: {
              "click": function ($event) {
                return action.onClick(s.row);
              }
            }
          }, [_vm._v(" " + _vm._s(action.name) + " ")])], 1);
        }), 0)];
      }
    }], null, false, 630630303)
  }) : _vm._e(), _vm.links && _vm.links.length > 0 ? _c('el-table-column', {
    attrs: {
      "label": "Links"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (s) {
        return [_vm._l(_vm.links.filter(function (l) {
          return !l.visible || l.visible(s.row);
        }), function (link) {
          return [link.href ? _c('a', {
            key: link.label,
            staticClass: "link",
            attrs: {
              "href": link.href(s.row),
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_vm._v(" " + _vm._s(link.label) + " ")]) : _c('router-link', {
            key: link.label,
            staticClass: "link",
            attrs: {
              "to": link.to(s.row),
              "tag": "a"
            }
          }, [_vm._v(" " + _vm._s(link.label) + " ")])];
        })];
      }
    }], null, false, 648304797)
  }) : _vm._e()], 2)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }